import script from "./MaxioProductDeal.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxioProductDeal.vue?vue&type=script&setup=true&lang=js"

import "./MaxioProductDeal.vue?vue&type=style&index=0&id=7e2e1dcc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2e1dcc"]])

export default __exports__